import { useState } from "react";

import { env } from "~/env";
import { ProviderAppointment } from "~/services/admin-providers";
import { Button, tw, useCooldown } from "~/shared";
import { icons } from "~/ui";
import { BookingConflictsTable } from "./BookingConflictsTable";

type Props = {
  appointments: ProviderAppointment[];
  totalConflicts: number;
  onRefresh: () => void;
  isFetching: boolean;
};

export const BookingConflictsSection = ({
  appointments,
  totalConflicts,
  onRefresh,
  isFetching,
}: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const isCooldown = useCooldown(
    isFetching,
    env.VITE_APPOINTMENT_VISITS_COOLDOWN,
  );

  return (
    <div className="flex w-full flex-col gap-3">
      <p className="text-poppyRed text-sm">
        <span className="font-bold">Booking Conflicts:</span> {totalConflicts}{" "}
        booked {totalConflicts > 1 ? "appointments" : "appointment"} no longer
        {totalConflicts > 1 ? " match" : " matches"} the active schedule
        template and must be rescheduled.
      </p>

      <div className="text-indigo flex items-center justify-between text-sm">
        <button
          type="button"
          onClick={() => setIsVisible((prev) => !prev)}
          className="flex items-center gap-2"
        >
          <span>
            {isVisible ? "Hide booking conflicts" : "View booking conflicts"}
          </span>
          {isVisible ? (
            <icons.outline.ChevronDownIcon className="stroke-3 size-4" />
          ) : (
            <icons.outline.ChevronRightIcon className="stroke-3 size-4" />
          )}
        </button>

        <Button
          variant="info"
          size="sm"
          className={tw(
            "text-vivid-blue !bg-vivid-blue/10 gap-2 rounded-md text-sm",
            !isVisible ? "pointer-events-none invisible" : "",
            isCooldown ? "opacity-50" : "",
          )}
          onClick={() => {
            if (!isFetching && !isCooldown) {
              onRefresh();
            }
          }}
          disabled={!isVisible || isFetching || isCooldown}
        >
          <icons.outline.ArrowPathIcon
            className={tw("size-5 stroke-2", isFetching ? "animate-spin" : "")}
          />
          Refresh visits
        </Button>
      </div>

      {isVisible && <BookingConflictsTable data={appointments} />}
    </div>
  );
};
